import React from 'react'
import {
  Definition,
  Section,
  SectionHeader,
  SectionBody,
} from '@apexinternal/ui-components'
import { FaArrowRight } from 'react-icons/fa'
import { BoxProps, Link, Icon } from '@chakra-ui/react'
import { isEmpty } from 'lodash'
import { MarginSummary } from 'types'
import { numberToDollars } from 'utils'
import { useAccountDetails } from 'hooks'
import { AccountTypeEnum } from 'types/AccountTypeEnum'
import { RoutesEnum } from 'types/RoutesEnum'
import { USD_DISCLAIMER } from 'constants/constants'

export interface MarginsTableProps extends BoxProps {
  margins?: MarginSummary
}

const MarginsTable = ({ margins, ...rest }: MarginsTableProps) => {
  const {
    accountDetailsState: { accountDetails },
  } = useAccountDetails()
  const accountNumber = accountDetails?.accountNumber
  const isMarginAccount = accountDetails?.accountType === AccountTypeEnum.Margin
  if (isEmpty(margins) || !isMarginAccount) return null
  return (
    <Section {...rest}>
      <SectionHeader
        tools={
          accountNumber &&
          isMarginAccount && (
            <Link
              href={`/${RoutesEnum.Accounts}/${accountNumber}/balances`}
              sx={{
                ':hover': {
                  color: 'apex.white',
                },
                color: 'apex.white',
                fontWeight: 'regular',
              }}
            >
              Balance Details <Icon as={FaArrowRight} color="apex.white" />
            </Link>
          )
        }
      >
        Margins
      </SectionHeader>
      <SectionBody>
        <Definition
          key="sma"
          term="S.M.A."
          definition={`${numberToDollars(margins?.sma || 0)}`}
        />
        <Definition
          key="marginExcess"
          term="Margin Excess"
          definition={`${numberToDollars(margins?.marginExcess || 0)}`}
        />
        <Definition
          key="dayTradeBuyingPower"
          term="Day Trade Buying Power"
          definition={`${numberToDollars(margins?.dayTradeBuyingPower || 0)}`}
        />
        <Definition
          key="disclaimer"
          term={USD_DISCLAIMER}
          definition=""
          borderBottom="none"
        />
      </SectionBody>
    </Section>
  )
}

export default MarginsTable
